module.exports = __webpack_public_path__ + "img/qu_tn.7742e65.jpg";